import React from 'react'
import PropTypes from 'prop-types'
import { Route, Redirect } from 'react-router-dom'

const PrivateRouteContext = React.createContext()

export const usePrivateRoute = () => {
  const context = React.useContext(PrivateRouteContext)

  return {
    ...context,
    isAuthenticated: context.authenticator(),
  }
}

export const PrivateRouteProvider = ({ authenticator, redirectTo, ...rest }) => {
  return <PrivateRouteContext.Provider value={{ authenticator, redirectTo }} {...rest} />
}

PrivateRouteProvider.propTypes = {
  authenticator: PropTypes.func.isRequired,
  redirectTo: PropTypes.string.isRequired,
}

export const PrivateRoute = ({ children, component, render, ...rest }) => {
  const { isAuthenticated, redirectTo } = usePrivateRoute()

  return (
    <Route
      {...rest}
      // must be render prop to render <Redirect> component when path is matched
      render={(route) =>
        isAuthenticated ? (
          <Route children={children} component={component} render={render} />
        ) : (
          <Redirect to={{ pathname: redirectTo, state: { from: route.location } }} />
        )
      }
    />
  )
}

PrivateRoute.propTypes = Route.propTypes
